var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"x":"0","y":"0","viewBox":"0 0 2160 3840"}},[_c('g',{ref:"svgone"}),_c('g',{ref:"svgtwo"}),_c('g',{ref:"svgthree"}),_c('g',{ref:"svgfour"}),_c('g',{ref:"gridGroup"}),_c('rect',{attrs:{"id":"svg-background"}})])}
var staticRenderFns = []

export { render, staticRenderFns }